export default __webpack_public_path__ + "static/media/top-dwtips.194f2d84.jpg";